enum PacksFilters {
  DateCreated = "dateAdded",
  DateModified = "lastModified",
  Category = "categoryIds",
  Industry = "industryIds",
  Publishers = "publisherIds",
  PricingType = "pricingTypeIds",
}

export default PacksFilters;
